import React from 'react'
import Header from './Header'
import Hero from './Hero'
import WhatWeDoIntro from './WhatWeDoIntro'
import Artists from './Artists'
import Testimonials from './Testimonials'
import VideoSection from './VideoSection'
// import Services from './Services'
import PricingGuide from './PricingGuide'
import Contact from './Contact'
import Footer from './Footer'
import { useSiteSettings } from '../hooks/useSiteSettings'

const HomePage: React.FC = () => {
  const { settings } = useSiteSettings()
  
  // Get feature flags from settings, with defaults
  const showPricingGuide = settings?.features?.pricingGuide ?? false
  const showContactForm = settings?.features?.contactForm ?? false

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <WhatWeDoIntro />
      <Artists />
      <Testimonials />
      <VideoSection />
      {/* <Services /> */}
      {showPricingGuide && <PricingGuide />}
      {showContactForm && <Contact />}
      <Footer />
    </div>
  )
}

export default HomePage
